import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, isDevMode } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './forum/header/header.component';
import { HeaderSearchBarComponent } from './forum/header-search-bar/header-search-bar.component';

import { CarouselModule } from 'ngx-owl-carousel-o';
import { CommonModule, DatePipe } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';


import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

import { DragDropModule } from '@angular/cdk/drag-drop';
// import { NgMatSearchBarModule } from 'ng-mat-search-bar';


import { APP_INITIALIZER } from '@angular/core';
import { AppSettings, APP_SETTINGS } from './settings';
import { SettingsService } from './settings.service';
import { HttpClient } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ForumComponent } from './forum/forum.component';
import { SharedModule } from './shared/shared.module';
import { KnowledgeBaseComponent } from './forum/knowledge-base/knowledge-base.component';
import {NgxPaginationModule} from 'ngx-pagination';
import { MetaModule } from '@ngx-meta/core';
import { LetsChatComponent } from './forum/lets-chat/lets-chat.component';


const appSettingsInitializer = (settingsService: SettingsService) => () =>
  settingsService.initialize();

const appSettingsFactory = (settingsService: SettingsService): AppSettings =>
  settingsService.settings;

const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY', // this is how your date will be parsed from Input
  },
  display: {
    dateInput: 'DD/MM/YYYY', // this is how your date will get displayed on the Input
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@NgModule({
  declarations: [AppComponent, ForumComponent],
  imports: [
    CommonModule,
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    MatSidenavModule,
    HeaderComponent,
    CarouselModule,
    MatTabsModule,
    MatTableModule,
    MatSortModule,
    MatBottomSheetModule,
    MatIconModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatSnackBarModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxPaginationModule,
    HeaderSearchBarComponent,
    LetsChatComponent,
    MetaModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appSettingsInitializer,
      deps: [SettingsService],
      multi: true,
    },
    {
      provide: APP_SETTINGS,
      useFactory: appSettingsFactory,
      deps: [SettingsService],
    },
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
